import React, {Component, ReactElement} from 'react'
import AdminAuthRepository from '../../__NoAutomatedTests/components/login/repository/AdminAuthRepository'
import {SessionStorageHelper} from '../../SessionStorageHelper'
import {
    AdminUserLoginInfo,
    BelongCondominiumInfo,
} from '../../__NoAutomatedTests/components/login/repository/AdminUserLoginInfo'
import {Box, Dialog, Divider} from '@mui/material'
import PPTextField from '../shared/forms/PPTextField'
import styled from 'styled-components'
import PPCheckboxGroup from '../shared/forms/PPCheckboxGroup'
import {AVAILABLE_SITE, DO_OR_NOT, MESSAGE_TYPE, VALID_OR_NOT_CHECK} from '../../CodeMaster'
import {AdminPrimaryButton} from '../../styledComponents/adminPage/Buttons'
import {Messages} from '../../Messages'
import NatMenuMasterRepo from '../../__NoAutomatedTests/components/menuMaster/repository/NatMenuMasterRepo'
import {Nullable} from '../../app/TypeHelpers'
import {
    HeadingAreaMessageComponent,
    HeadingAreaMessageParams,
} from '../shared/pageBaseComponents/HeadingAreaMessageComponent'
import {getQueryParameter, NatAsyncCallFunction, setSessionStorage} from '../../__NoAutomatedTests/common/util/Natutil'
import NatCurrentDateTimeRepo
    from '../../__NoAutomatedTests/components/currentDateTime/repository/NatCurrentDateTimeRepo'
import NatSessionRepo from '../../__NoAutomatedTests/components/session/repository/NatSessionRepo'
import {
    NatAdminLoginInfoSessionStorageHelper,
} from '../../__NoAutomatedTests/common/authentication/NatAdminLoginInfoSessionStorageHelper'
import {
    NatGetMenuMasterAuthedAdmin,
} from '../../__NoAutomatedTests/components/menuMaster/repository/NatGetMenuMasterAuthedAdmin'
import {ApiResponse} from '../../network/response/ApiResponse'
import {CookieHelper} from '../../CookieHelper'
import {Colors, FontWeights} from '../../styledComponents/Constants'
import {StyledPre} from '../../styledComponents/adminPage/StyledPre'
import {AdminPagePropsSet, createAdminPage} from '../shared/hoc/createAdminPage'
import {FlexGridArea} from '../../styledComponents/GridComponents'
import {AppAdminContext} from '../../app/AppAdminContext'
import AdminAssocCondominiumSelectionDialogPc from './AdminAssocCondominiumSelectionDialogPc'
import {AdminDialog} from '../shared/pageBaseComponents/AdminDialog'
import AdminAssocCondominiumSelectionDialogSp from './AdminAssocCondominiumSelectionDialogSp'
import {Location} from 'react-router-dom'
import {
    NatCreateGenerateRequestParam
} from '../../__NoAutomatedTests/components/residentUser/repository/NatCreateGenerateRequestParam';
import NatResidentUserRepo, {
    CreateAuthorizeRequest,
    SetSeverSessionInfoRequest
} from '../../__NoAutomatedTests/components/residentUser/repository/NatResidentUserRepo';
import {NatCreateAuthorizeUrl} from '../../__NoAutomatedTests/components/residentUser/repository/NatCreateAuthorizeUrl';
import {BlockSpacer} from '../../styledComponents/ResponsiveConvenience';
import {
    NatSetServerSessionInfo
} from '../../__NoAutomatedTests/components/residentUser/repository/NatSetServerSessionInfo';
import {
    NatGetCurrentDateTime
} from '../../__NoAutomatedTests/components/currentDateTime/repository/NatGetCurrentDateTime';

interface Props {
    adminAuthRepo: AdminAuthRepository
    menuMasterRepo: NatMenuMasterRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    location: Location
    sessionRepo: NatSessionRepo
    residentUserRepo: NatResidentUserRepo
}

interface State {
    mailAddress: string
    password: string
    keepMailAddress: string
    errorMessage: string
    condominiumSelectDialogOpen: boolean
    belongCondominiumInfoList: BelongCondominiumInfo[]
}

const KEY_MAIL_ADDRESS: string = 'adminMailAddress'
const KEY_SENI_URL = 'seniUrl'

class NatAdminAssocLoginPage extends Component<Props & AdminPagePropsSet, State> {
    declare context: React.ContextType<typeof AppAdminContext>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        const {NOT} = VALID_OR_NOT_CHECK
        this.state = {
            mailAddress: '',
            password: '',
            keepMailAddress: NOT.value,
            errorMessage: '',
            condominiumSelectDialogOpen: false,
            belongCondominiumInfoList: [],
        }

        this.handleOkButtonClick = this.handleOkButtonClick.bind(this)
        this.handleCancelButtonClick = this.handleCancelButtonClick.bind(this)
        this.handleLoginButtonClick = this.handleLoginButtonClick.bind(this)
        this.handleCondominiumSelectButtonClick = this.handleCondominiumSelectButtonClick.bind(this)
        this.handleCloseForCondominiumSelectDialog = this.handleCloseForCondominiumSelectDialog.bind(this)
    }

    async componentDidMount(): Promise<void> {
        if (sessionStorage.length > 0) {
            await this.logoutProcedure()
        }

        await this.props.asyncCallFunction(
            this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
            (httpErrorOrNetworkError) => {
                this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )

        const mailAddress = CookieHelper.getStringValue(KEY_MAIL_ADDRESS)
        if (mailAddress) {
            const {VALID} = VALID_OR_NOT_CHECK
            this.setState({
                mailAddress: mailAddress,
                keepMailAddress: VALID.value,
            })
        }
        this.showInitialMessage()
    }

    async logoutProcedure(): Promise<void> {
        // NOTE: 機会があるときにAdminSessionUtilのログアウト処理に統合する
        await this.props.eventEmitter.showLoading()
        try {
            await this.props.asyncCallFunction(
                this.props.adminAuthRepo.logout.bind(this.props.adminAuthRepo),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
            await this.props.asyncCallFunction(
                this.props.sessionRepo.postAdminUseSite.bind(this.props.sessionRepo),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
            SessionStorageHelper.removeAllItem()
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    showInitialMessage(): void {
        const sessionTimeOut: string = getQueryParameter('sessionTimeOut', window.location.href)
        let initialMessage: Nullable<HeadingAreaMessageParams> = null

        if (sessionTimeOut === DO_OR_NOT.DO.value) {
            initialMessage = {
                title: null,
                messageLevel: MESSAGE_TYPE.WARNING,
                detail: Messages.ESYCC0021.toString(),
            }
        } else if (this.props.location && this.props.location.state) {
            initialMessage = this.props.location.state.initialMessage
            this.props.navigate(this.props.location.pathname, {replace: true})
        } else {
            return
        }

        if (initialMessage) {
            this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
        }
    }

    async selectLoginUser(condominiumCd: string): Promise<void> {
        const {
            adminAuthRepo,
            menuMasterRepo,
            navigate,
            location,
            eventEmitter,
            asyncCallFunction,
        } = this.props

        // CSRFトークンを設定するために、GETのAPIを実行
        await this.props.asyncCallFunction(
            this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
            (httpErrorOrNetworkError) => {
                this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )

        const adminUserLoginInfoBean: Nullable<ApiResponse<AdminUserLoginInfo>> = await asyncCallFunction(
            adminAuthRepo.selectAssocUser.bind(
                adminAuthRepo,
                condominiumCd,
            ),
            (httpErrorOrNetworkError) => {
                eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )

        if (adminUserLoginInfoBean == null || adminUserLoginInfoBean.details == null) {
            return
        }

        NatAdminLoginInfoSessionStorageHelper.setSessionStorage(adminUserLoginInfoBean.details)

        let nextUrl: { pathname?: string, search?: string } = {}
        const seniUrl: string = getQueryParameter('seniurl', location.search)
        if (seniUrl) {
            nextUrl = {
                pathname: seniUrl.split('?')[0],
                search: seniUrl.split('?')[1],
            }
        }
        if (!nextUrl.pathname) {
            // 一番左（最初）のメニューを取得
            const menuInfo: Nullable<NatGetMenuMasterAuthedAdmin> = await asyncCallFunction(
                menuMasterRepo.getMenuMasterAuthedAdmin.bind(menuMasterRepo),
                (httpErrorOrNetworkError) => {
                    eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (menuInfo === null) {
                return
            }

            nextUrl.pathname = menuInfo.details?.[0]?.childMenuInfo?.[0]?.url
            if (!nextUrl.pathname) {
                // メニューが取得できない場合はエラー表示する
                this.setState({condominiumSelectDialogOpen: false})
                const headingAreaMessageParams: HeadingAreaMessageParams = {
                    messageLevel: MESSAGE_TYPE.ERROR,
                    title: null,
                    detail: '物件に利用できる機能がないため、ログインできませんでした。',
                }
                await this.props.eventEmitter.showHeadingAreaMessage(headingAreaMessageParams)
                await this.logoutProcedure()
                return
            }
        }
        navigate(nextUrl)
    }

    async handleOkButtonClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.logoutProcedure()
        await this.assocLogin()
    }

    handleCancelButtonClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleLoginButtonClick(): Promise<void> {
        const isSutekiNetSmartPhoneApplication = SessionStorageHelper
            .getStringItemWithDefault('isSutekiNetSmartPhoneApplication', 'false')

        if (isSutekiNetSmartPhoneApplication === 'true') {
            const setSeverSessionInfoRequestSp: SetSeverSessionInfoRequest = {
                authenticationKey: null,
                ssoLoginCondominiumCd: null,
                ssoLoginRidgeCd: null,
                ssoLoginRoomNumber: null,
                loginPage: null,
                token: null,
                isSutekiNetSmartPhoneApplication: isSutekiNetSmartPhoneApplication
            };
            const retSp: Nullable<NatSetServerSessionInfo> =
                await NatAsyncCallFunction(this.props.residentUserRepo.setBackendSessionInfo.bind(
                        this.props.residentUserRepo, setSeverSessionInfoRequestSp),
                    this.props.navigate
                );
        }
        const response = await this.props.asyncCallFunction(
            this.props.sessionRepo.getLoginStatus.bind(this.props.sessionRepo),
            (httpErrorOrNetworkError) => {
                this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        if (response === null) {
            return
        }

        if (response === AVAILABLE_SITE.NOT_LOGIN.value) {
            await this.assocLogin()
        } else {
            let errorLevel: MESSAGE_TYPE
            let errorMessage: string
            if (response === AVAILABLE_SITE.RESIDENT.value) {
                errorLevel = Messages.WOPCA0005.errorLevel
                errorMessage = Messages.WOPCA0005.toString()
            } else if (response === AVAILABLE_SITE.ADMIN.value) {
                errorLevel = Messages.WOPCA0006.errorLevel
                errorMessage = Messages.WOPCA0006.toString()
            } else {
                errorLevel = Messages.WOPCA0007.errorLevel
                errorMessage = Messages.WOPCA0007.toString()
            }

            await this.props.eventEmitter.showDialog({
                    title: '確認',
                    errorLevel: errorLevel,
                    message: errorMessage,
                    buttonProps: [
                        {
                            isDefault: false,
                            buttonLabel: 'キャンセル',
                            buttonHandler: this.handleCancelButtonClick,
                        },
                        {
                            isDefault: false,
                            buttonLabel: 'OK',
                            buttonHandler: this.handleOkButtonClick,
                        },
                    ],
                },
            )
        }
    }

    async assocLogin(): Promise<void> {
        await this.props.eventEmitter.clearHeadingAreaMessage()
        await this.props.eventEmitter.showLoading()

        this.setState({errorMessage: ''})

        const {VALID} = VALID_OR_NOT_CHECK

        // 必要な情報をサーバのセッションに設定
        const setSeverSessionInfoRequest: SetSeverSessionInfoRequest = {
            authenticationKey: '',
            ssoLoginCondominiumCd: '',
            ssoLoginRidgeCd: '',
            ssoLoginRoomNumber: '',
            loginPage: 'NatAdminAssocLoginPage',
            token: '',
            isSutekiNetSmartPhoneApplication: null
        };

        await NatAsyncCallFunction(this.props.residentUserRepo.setBackendSessionInfo.bind(
                this.props.residentUserRepo, setSeverSessionInfoRequest),
            this.props.navigate
        );

        try {
            const currentDateTime: Nullable<NatGetCurrentDateTime> =
                await this.props.asyncCallFunction(
                    this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )

            // ログイン認証
            // ステート、ノンス取得し、セッションへ格納
            const createGenerateRequestParam: Nullable<NatCreateGenerateRequestParam> =
                await NatAsyncCallFunction(
                    this.props.residentUserRepo.createGenerateRequestParam.bind(
                        this.props.residentUserRepo), this.props.navigate);
            let mailAddressForParam = null;
            if (currentDateTime && currentDateTime.details) {
                const currentDate = new Date(currentDateTime.details.currentDateTime);
                // 2026/4/1以降は無効化
                const cutoffDate = new Date(2026, 3, 1, 0, 0, 0, 0);
                const isValidDate = currentDate < cutoffDate;

                if (isValidDate) {
                    // 2026/3/31以前ならCookieからメールアドレスを取得
                    if (this.state.keepMailAddress === VALID.value) {
                        mailAddressForParam = this.state.mailAddress
                    }
                }
            }
            if (createGenerateRequestParam) {
                // パラメータ作成
                const createAuthorizeRequest: CreateAuthorizeRequest = {
                    mailAddress: mailAddressForParam ? encodeURIComponent(mailAddressForParam) : null,
                };
                const natCreateAuthorizeUrl: Nullable<NatCreateAuthorizeUrl> =
                    await NatAsyncCallFunction(
                        this.props.residentUserRepo.createAuthorize.bind(
                            this.props.residentUserRepo, createAuthorizeRequest), this.props.navigate);
                if (natCreateAuthorizeUrl && natCreateAuthorizeUrl.details) {
                    const seniurl: string = getQueryParameter('seniurl', this.props.location.search);
                    if (seniurl) {
                        setSessionStorage(KEY_SENI_URL, seniurl);
                    }
                    window.location.href = natCreateAuthorizeUrl.details;
                }
            }
        } catch (e) {
            this.setState({errorMessage: Messages.ESYCC0015.message})
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    handleMailAddressInputChange(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({mailAddress: event.target.value})
    }

    handlePasswordInputChange(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({password: event.target.value})
    }

    handleMailAddressCheckChange(): void {
        if (this.state.keepMailAddress === VALID_OR_NOT_CHECK.VALID.value) {
            this.setState({keepMailAddress: VALID_OR_NOT_CHECK.NOT.value})
        } else {
            this.setState({keepMailAddress: VALID_OR_NOT_CHECK.VALID.value})
        }
    }

    handleCloseForCondominiumSelectDialog = async () => {
        try {
            await this.props.asyncCallFunction(
                this.props.adminAuthRepo.logout.bind(this.props.adminAuthRepo),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
        } finally {
            this.setState({condominiumSelectDialogOpen: false})
        }
    }

    async handleCondominiumSelectButtonClick(condominiumCd: string): Promise<void> {
        await this.selectLoginUser(condominiumCd)
    }

    render(): ReactElement {
        const labels: { label: string, checked: boolean }[] = [{
            label: '次回からメールアドレスの入力を省略する',
            checked: this.state.keepMailAddress === VALID_OR_NOT_CHECK.VALID.value,
        }]
        const {
            condominiumSelectDialogOpen,
            belongCondominiumInfoList,
        } = this.state

        const loginButtonDisabled = this.state.mailAddress === '' || this.state.password === ''

        const spMode = this.context.showSpModePage

        return (<>
            <MainContainer>
                <Box height={spMode ? '9px' : '25px'}/>
                <HeaderArea $spMode={spMode}>
                    <HeaderIconImage src={'/resources/images/assoc/assoc_login_black.svg'} $spMode={spMode}/>
                    <HeaderTitle>管理組合役員の方</HeaderTitle>
                </HeaderArea>
                <StyledDivider/>
                <HeadingAreaMessageComponent eventEmitter={this.props.eventEmitter}/>
                <InfoMessageArea>
                    素敵ネットに登録済みのメールアドレスとパスワードを使ってログインいただけます。
                </InfoMessageArea>
                <BlockSpacer height={'15px'}/>
                <FlexGridArea area={'errorMessage'}>
                    {this.state.errorMessage !== '' &&
                        <ErrorMsg>{this.state.errorMessage}</ErrorMsg>}
                </FlexGridArea>
                <FlexGridArea area={'loginButton'}>
                    <LoginButton
                        $spMode={spMode}
                        id={'loginBtn'}
                        onClick={this.handleLoginButtonClick}
                    >
                        ログインする
                    </LoginButton>
                </FlexGridArea>
            </MainContainer>

            {condominiumSelectDialogOpen &&
            spMode ?
                <AdminDialog open={condominiumSelectDialogOpen}>
                    <AdminAssocCondominiumSelectionDialogSp
                        belongCondominiumInfoList={belongCondominiumInfoList}
                        handleCondominiumSelectButtonClick={this.handleCondominiumSelectButtonClick}
                        handleCloseForCondominiumSelectDialog={this.handleCloseForCondominiumSelectDialog}
                    />
                </AdminDialog>
                :
                <Dialog
                    id={'pp-dialog'}
                    open={condominiumSelectDialogOpen}
                    transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
                    maxWidth={'md'}
                    fullWidth
                >
                    <AdminAssocCondominiumSelectionDialogPc
                        belongCondominiumInfoList={belongCondominiumInfoList}
                        handleCondominiumSelectButtonClick={this.handleCondominiumSelectButtonClick}
                        handleCloseForCondominiumSelectDialog={this.handleCloseForCondominiumSelectDialog}
                    />
                </Dialog>
            }
        </>)
    }
}

const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
`

const HeaderArea = styled.div<{ $spMode: boolean }>`
    display: flex;
    flex-direction: row;
    font-weight: ${FontWeights.Bold};
    align-items: center;
    ${props => props.$spMode ? `
     font-size: 16px;
  ` : `
     font-size: 24px;
  `}
`

const HeaderIconImage = styled.img<{ $spMode: boolean }>`
    ${props => props.$spMode ? `
     width: 20px;
     height: 20px;
  ` : `
     width: 24px;
     height: 24px;
  `}
`

const HeaderTitle = styled.div`
    margin-left: 4px
`

const StyledDivider = styled(Divider)`
    margin: 4px 0 16px 0;
    height: 2px;
    background: linear-gradient(0deg, rgba(29, 37, 84, 0.20) 0%, rgba(29, 37, 84, 0.20) 100%), #FFF;
    filter: drop-shadow(1px 1px 1px rgba(29, 37, 84, 0.40));
`

const InfoMessageArea = styled.div`
`

const MainArea = styled.div<{ $spMode: boolean }>`
    background-color: ${Colors.Surface};
    display: grid;
    ${props => props.$spMode ? `
  margin: 16px -15px;
  padding: 16px;
  grid-template:
    "mailAddressLabel"
    "."                5px
    "mailAddressInput"
    "keepMailAddressCheck"
    "."                15px
    "passwordLabel"
    "."                5px
    "passwordInput"
    "errorMessage"
    "."                32px
    "loginButton"
    "."                16px
     / 1fr;
  ` : `
  margin-top: 16px;
  padding: 20px 40px 24px;
  grid-template:
    "mailAddressLabel mailAddressInput     ."
    ".                keepMailAddressCheck ."
    ".                .                    ." 28px
    "passwordLabel    passwordInput        ."
    "errorMessage     errorMessage         ."
    ".                .                    ." 24px
    ".                .                    loginButton"
     / max-content 1fr max-content;
  column-gap: 40px;
  `}
`

const RowTitle = styled.div`
    font-size: 16px;
    color: ${Colors.AccentDark};
`

const MailAddressInput = styled(PPTextField)<{ $spMode: boolean }>`
    ${props => props.$spMode ? `
  width: 100%;
  ` : `
  width: 480px;
  `}
`

const PasswordInput = styled(PPTextField)<{ $spMode: boolean }>`
    ${props => props.$spMode ? `
  width: 100%;
  ` : `
  width: 480px;
  `}
`

const StyledPPCheckboxGroup = styled(PPCheckboxGroup)`
    .MuiCheckbox-root {
        padding: 4px;
        margin-left: 7px;
    }

    .MuiTypography-root {
        font-size: 14px;
        color: ${Colors.AccentDark};
    }
`

const ErrorMsg = styled(StyledPre)`
    margin-top: 16px;
    color: ${Colors.Alert};
`

const LoginButton = styled(AdminPrimaryButton)<{ $spMode: boolean }>`
    ${props => props.$spMode && `
  width: 100%;
  `}
`

NatAdminAssocLoginPage.contextType = AppAdminContext
export default createAdminPage(NatAdminAssocLoginPage)
